import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackJustifyContent, StackSelfContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { appendCounter, minusCounter, onChangeTab, onCtaCopyLink, onCtaShareLink, onCtaTelegram, onCtaWhatsApp, onFaq, onKnowMore, onSearchReferredPartner, } from './actions';
import { platformApi, StoreKey } from '../../configs/api';
import { getAppHeader, initializeFirebase } from '../../configs/config';
import { isMobile } from '../../configs/utils';
import { PartnerHeader } from "../dashboard/partnerHeader";
import { PlatformSideNav } from "../../partnerWeb_Features/sideNavBar/platformSideNav";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../../partnerWeb_Features/partnerSignUp/actions";
import { onLogoutPress, openMenu } from "../dashboard/actions";
import sharedPropsService from "../../SharedPropsService";
import { ReferredPartnerMobileCardBuilder, ReferredPartnerTableBuilder } from "../dashboard/utils";
import { debounce } from "lodash";
export const template = async (firstRenderArray, referredPartnerData, totalNoOfPages, currentPageNo) => {
    return ({
        layout: {
            id: ROUTE.PLATFORM_LINKED_PARTNERS,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true,
            },
            widgets: [
                {
                    id: 'partnerHeader',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_TOP,
                },
                !isMobile()
                    ? {
                        id: 'sideNav',
                        type: WIDGET.STACK,
                        position: POSITION.NAVBAR_LEFT,
                    }
                    : {},
                !isMobile()
                    ? { id: 'referredPartnerRGStack', type: WIDGET.STACK }
                    : { id: 'referredPartnerMobStack', type: WIDGET.STACK },
            ],
        },
        datastore: {
            ...(await PartnerHeader(ROUTE.PLATFORM_LINKED_PARTNERS, true)),
            ...(await PlatformSideNav(ROUTE.PLATFORM_LINKED_PARTNERS)),
            referredPartnerMobStack: {
                height: StackHeight.MATCH_PARENT,
                type: StackType.column,
                padding: {
                    all: SizeTypeTokens.XL
                },
                widgetItems: referredPartnerData?.length > 0
                    ? [
                        { id: 'referredPartnerCountText', type: WIDGET.TEXT },
                        { id: 'referredPartnerspace0', type: WIDGET.SPACE },
                        { id: 'referredPartnerMobSearchInput', type: WIDGET.INPUT },
                        { id: 'referredPartnerMobSpace8', type: WIDGET.SPACE },
                        { id: 'referredPartnerCardStack', type: WIDGET.STACK }
                    ] :
                    [{ id: 'referredPartnerTitleMob', type: WIDGET.TEXT },
                        { id: 'referredPartnerspace0', type: WIDGET.SPACE },
                        {
                            id: 'emptyStateStack_ReferredPartner',
                            type: WIDGET.STACK,
                        }
                    ]
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL
            },
            referredPartnerCardStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    ...ReferredPartnerMobileCardBuilder(referredPartnerData).WIDGET_STORE
                ]
            },
            referredPartnerTitleMob: {
                label: 'Referred Partners',
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
            },
            ...ReferredPartnerMobileCardBuilder(referredPartnerData).DATA_STORE,
            referredPartnerMobSearchInput: {
                title: 'Search Linked Partners',
                value: '',
                placeholder: 'Search by name or mobile',
                type: InputTypeToken.DEFAULT,
                isFocus: false,
                action: {
                    type: ACTION.ON_SEARCH_RP,
                    routeId: ROUTE.PLATFORM_LINKED_PARTNERS,
                    payload: {
                        value: '',
                        widgetId: 'referredPartnerMobSearchInput',
                    },
                },
            },
            referredPartnerMobSpaceT1: {
                label: 'Referred Partners',
                fontSize: FontSizeTokens.LG,
                fontWeight: '600',
                fontFamily: FontFamilyTokens.Poppins,
                lineHeight: 26,
                color: ColorTokens.Grey_Charcoal
            },
            referredPartnerMobSpace8: {
                size: SizeTypeTokens.XL
            },
            referredPartnerMobSpace7: {
                size: SizeTypeTokens.XL
            },
            referredPartnerMobTandCBtn: {
                label: 'View all T&C',
                width: ButtonWidthTypeToken.FULL,
                type: ButtonTypeTokens.MediumSoftFilled,
                action: {
                    type: ACTION.FAQ,
                    routeId: ROUTE.PLATFORM_LINKED_PARTNERS,
                    payload: {},
                },
            },
            rewardStructureMobT1: {
                label: `Reward structure`,
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.LG,
                fontWeight: '600',
                lineHeight: 26,
                color: ColorTokens.Grey_Night,
            },
            referMfdAndAdvisorsStackMob: {
                width: StackWidth.MATCH_PARENT,
                type: StackType.column,
                padding: {
                    top: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'referMfdAndAdvisorsStackT1Mob', type: WIDGET.TEXT },
                    { id: 'referMfdAndAdvisorsStackT2', type: WIDGET.TEXT },
                    { id: 'referredPartnerMobSpace2', type: WIDGET.SPACE },
                    { id: 'referMfdAndAdvisorsTelegramMob', type: WIDGET.BUTTON },
                    { id: 'referMfdAndAdvisorsMobBottomStack', type: WIDGET.STACK },
                ],
            },
            referMfdAndAdvisorsTelegramMob: {
                label: 'Whatsapp',
                width: ButtonWidthTypeToken.FULL,
                type: ButtonTypeTokens.MediumFilled,
                icon: {
                    name: IconTokens.Whatsapp,
                },
            },
            referMfdAndAdvisorsMobBottomStack: {
                width: StackWidth.MATCH_PARENT,
                type: StackType.row,
                padding: {
                    top: SizeTypeTokens.XL,
                },
                widgetItems: [
                    {
                        id: 'referMfdAndAdvisorsMobBottomStack1',
                        type: WIDGET.STACK,
                    },
                    {
                        id: 'referredPartnerMobSpace1',
                        type: WIDGET.SPACE,
                    },
                    {
                        id: 'referMfdAndAdvisorsMobBottomStack2',
                        type: WIDGET.STACK,
                    },
                ],
            },
            referMfdAndAdvisorsMobBottomStack1: {
                flex: 1,
                widgetItems: [
                    {
                        id: 'referMfdAndAdvisorsMobBottomStackButton1',
                        type: WIDGET.BUTTON,
                    },
                ],
            },
            referMfdAndAdvisorsMobBottomStack2: {
                flex: 1,
                widgetItems: [
                    {
                        id: 'referMfdAndAdvisorsMobBottomStackButton2',
                        type: WIDGET.BUTTON,
                    },
                ],
            },
            referMfdAndAdvisorsMobBottomStackButton1: {
                label: 'Telegram',
                width: ButtonWidthTypeToken.FULL,
                type: ButtonTypeTokens.MediumSoftFilled,
                icon: {
                    name: IconTokens.Telegram,
                },
            },
            referMfdAndAdvisorsMobBottomStackButton2: {
                label: 'Share Link',
                width: ButtonWidthTypeToken.FULL,
                type: ButtonTypeTokens.MediumSoftFilled,
                icon: {
                    name: IconTokens.Share,
                },
            },
            referredPartnerRGStack: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.MATCH_PARENT,
                type: StackType.column,
                flex: 1,
                padding: {
                    top: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                    left: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                    right: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                },
                widgetItems: [
                    { id: 'referredPartnerCountText', type: WIDGET.TEXT },
                    { id: 'referredPartnerspace0', type: WIDGET.SPACE },
                    { id: "firstRenderStack", type: WIDGET.STACK }
                ],
            },
            firstRenderStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                widgetItems: firstRenderArray.length > 0 ?
                    [
                        { id: 'referredPartnertopStack', type: WIDGET.STACK },
                        { id: 'referredPartnerspace2', type: WIDGET.SPACE },
                        { id: 'spaceStack', type: WIDGET.STACK },
                        {
                            id: 'referredPartnerTableStack',
                            type: WIDGET.STACK,
                        }
                    ] : [
                    {
                        id: 'emptyStateStack_ReferredPartner',
                        type: WIDGET.STACK,
                    }
                ]
            },
            spaceStack: {
                type: StackType.column,
                hide: true,
                widgetItems: [
                    { id: 'referredPartnerspace2', type: WIDGET.SPACE },
                ]
            },
            rewardStructureImageWeb: {
                title: 'https://volt-images.s3.ap-south-1.amazonaws.com/rewardStructureNew1.png',
            },
            rewardStructureButtonViewAllTandC: {
                label: 'View all T&C',
                width: ButtonWidthTypeToken.CONTENT,
                type: ButtonTypeTokens.MediumSoftFilled,
                action: {
                    type: ACTION.FAQ,
                    routeId: ROUTE.PLATFORM_LINKED_PARTNERS,
                    payload: {},
                },
            },
            referredPartnerDivider1: {
                color: ColorTokens.Grey_Chalk,
                size: DividerSizeTokens.SM,
            },
            referMfdAndAdvisorsStackT1Mob: {
                label: `Refer MFDs or advisors `,
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.LG,
                fontWeight: '600',
                lineHeight: 26,
                color: ColorTokens.Grey_Night,
            },
            referredPartnerTopStack1: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [{ id: 'PromotionCard', type: WIDGET.PROMOTION_CARD }],
            },
            PromotionCard: {
                title: 'something',
                action: {
                    type: ACTION.KNOW_MORE,
                    routeId: ROUTE.PLATFORM_LINKED_PARTNERS,
                    payload: {},
                },
                isCta: isMobile() ? false : true,
            },
            emptyStateStack_ReferredPartner: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                alignContent: StackAlignContent.center,
                padding: {
                    top: SizeTypeTokens.XL,
                },
                widgetItems: [
                    {
                        id: 'noDataIcon_ReferredPartnerEmpty',
                        type: WIDGET.ICON,
                    },
                    {
                        id: 'noDataText1_ReferredPartnerEmpty',
                        type: WIDGET.TEXT,
                    },
                    {
                        id: 'noDataText2_ReferredPartnerEmpty',
                        type: WIDGET.TEXT,
                    },
                    {
                        id: 'noDataText3_ReferredPartnerEmpty',
                        type: WIDGET.TEXT,
                    },
                ],
            },
            noDataIcon_ReferredPartnerEmpty: {
                name: IconTokens.List,
                size: IconSizeTokens.XXXXXXXXL,
            },
            noDataText1_ReferredPartnerEmpty: {
                label: `No partners added`,
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.XXL,
                fontWeight: '600',
                lineHeight: 32,
                color: ColorTokens.Grey_Night,
            },
            noDataText2_ReferredPartnerEmpty: {
                label: `Partners will reflect as soon as they register.`,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 20,
                color: ColorTokens.Grey_Charcoal,
            },
            noDataText3_ReferredPartnerEmpty: {
                label: ``,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 20,
                color: ColorTokens.Grey_Charcoal,
            },
            referredPartnerCountText: {
                label: `Referred partners`,
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.LG,
                fontWeight: '600',
                lineHeight: 26,
                color: ColorTokens.Grey_Night
            },
            referredPartnerTable: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.MATCH_PARENT,
                titleMap: {
                    ...ReferredPartnerTableBuilder(firstRenderArray).Title_MAP,
                },
                titleConfig: {
                    ...ReferredPartnerTableBuilder(firstRenderArray)
                        .TITLE_CONFIG,
                },
                widgetData: {
                    ...ReferredPartnerTableBuilder(firstRenderArray).DATA,
                },
                data: firstRenderArray,
            },
            ...ReferredPartnerTableBuilder(firstRenderArray).DATA_STORE,
            referredPartnerTableStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.MATCH_PARENT,
                widgetItems: [
                    { id: 'referredPartnerTableStack1', type: WIDGET.STACK },
                ],
            },
            referredPartnerTableStack1: {
                maxWidth: 900,
                widgetItems: [
                    { id: 'referredPartnerTable', type: WIDGET.TABLE },
                    { id: "spaceXXL", type: WIDGET.SPACE },
                    { id: "pageNumberStack", type: WIDGET.STACK }
                ],
            },
            referredPartnertopStack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: 'referredPartnerSearchStackLeft', type: WIDGET.STACK },
                    { id: 'referredPartnerSearchStackRight', type: WIDGET.STACK },
                ],
            },
            referredPartnerSearchStackLeft: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                flex: 1,
                widgetItems: [
                    { id: 'referredPartnerSeachInput', type: WIDGET.INPUT },
                ],
            },
            referredPartnerSearchStackRight: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                flex: 2,
                widgetItems: [],
            },
            pageNumberStack: {
                type: StackType.row,
                justifyContent: StackJustifyContent.spaceBetween,
                width: StackWidth.MATCH_PARENT,
                padding: {
                    left: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.NONE,
                    right: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.NONE,
                },
                widgetItems: [
                    {
                        id: "previousPageStack", type: WIDGET.STACK
                    },
                    {
                        id: "pageNumberMentionStack", type: WIDGET.STACK
                    },
                    {
                        id: "nextPageStack", type: WIDGET.STACK
                    }
                ]
            },
            pageNumberMentionStack: {
                type: StackType.row,
                widgetItems: [
                    { id: "currentPageNumber", type: WIDGET.TEXT },
                    { id: "pageNumber", type: WIDGET.TEXT },
                ]
            },
            currentPageNumber: {
                label: `Page ${currentPageNo}`,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            pageNumber: {
                label: ` of ${totalNoOfPages}`,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            previousPageStack: {
                type: StackType.row,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    {
                        id: "leftIcon", type: WIDGET.ICON
                    },
                    {
                        id: "previousText", type: WIDGET.TEXT
                    }
                ],
                action: {
                    routeId: ROUTE.PLATFORM_LINKED_PARTNERS,
                    type: ACTION.MINUS_COUNTER
                }
            },
            nextPageStack: {
                type: StackType.row,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    {
                        id: "nextText", type: WIDGET.TEXT
                    },
                    {
                        id: "rightIcon", type: WIDGET.ICON
                    },
                ],
                action: {
                    routeId: ROUTE.PLATFORM_LINKED_PARTNERS,
                    type: ACTION.APPEND_COUNTER,
                    payload: {
                        value: currentPageNo,
                        array: referredPartnerData,
                        totalNoOfPages: totalNoOfPages
                    }
                }
            },
            leftIcon: {
                name: IconTokens.LeftBlackArrowIcon,
                size: IconSizeTokens.XL,
                color: ColorTokens.Grey_Charcoal
            },
            rightIcon: {
                name: IconTokens.RightBlackIcon,
                size: IconSizeTokens.XL,
                color: ColorTokens.Grey_Night
            },
            previousText: {
                label: 'Previous',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            nextText: {
                label: 'Next',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Night
            },
            referredPartnerSeachInput: {
                title: 'Search Linked Partners',
                value: '',
                placeholder: 'Search by name, mobile, partner code',
                type: InputTypeToken.DEFAULT,
                action: {
                    type: ACTION.ON_SEARCH_RP,
                    routeId: ROUTE.PLATFORM_LINKED_PARTNERS,
                    payload: {
                        value: '',
                        widgetId: 'referredPartnerSeachInput',
                    },
                },
            },
            referredPartnerspace0: { size: SizeTypeTokens.XXXL },
            referredPartnerspace1: { size: SizeTypeTokens.LG },
            referredPartnerspace2: { size: SizeTypeTokens.LG },
            referredPartnerspace3: { size: SizeTypeTokens.Size32 },
            referredPartnerspace7: { size: SizeTypeTokens.Size32 },
            referredPartnerspace8: { size: SizeTypeTokens.Size32 },
            referredPartnerspace9: { size: SizeTypeTokens.XL },
            referredPartnerspace10: { size: SizeTypeTokens.XL },
            referredPartnerspace11: { size: SizeTypeTokens.Size32 },
            referredPartnerMobSpace0: { size: SizeTypeTokens.XL },
            referredPartnerMobSpace1: { size: SizeTypeTokens.XL },
            referredPartnerMobSpace2: { size: SizeTypeTokens.XL },
            referredPartnerMobSpace3: { size: SizeTypeTokens.XXXL },
            referredPartnerMobSpace4: { size: SizeTypeTokens.XL },
            referredPartnerMobSpace5: { size: SizeTypeTokens.XL },
            referredPartnerMobSpace6: { size: SizeTypeTokens.XL },
        },
    });
};
export const platformLinkedPartnersMF = {
    onLoad: async ({ asyncStorage, network, instrumentTrack, ...props }, { setIsUserLoggedIn: boolean }) => {
        await initializeFirebase();
        const header = await getAppHeader();
        header['X-AppPlatform'] = await asyncStorage.get(StoreKey.APP_PLATFORM);
        const response = await network.get(`${platformApi.linkedPartners}1`, {
            headers: header
        }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        let firstRenderArray = [];
        firstRenderArray = response.data.partnersMetaDataForPlatformList;
        instrumentTrack("INVITE_PARTNER_PAGE_VIEWED");
        const totalNoOfPages = response?.data?.totalPages;
        const currentPageNo = response?.data?.currentPage;
        const array = [];
        if (firstRenderArray.length > 0) {
            for (let i = currentPageNo; i <= totalNoOfPages; i++) {
                network.get(`${platformApi.linkedPartners}${i}`, {
                    headers: header
                }, async () => {
                    return;
                }, {
                    isPartnerPlatform: true,
                }).then(response => {
                    array.push(...response.data.partnersMetaDataForPlatformList);
                    sharedPropsService.setLinkedPartnersList(array);
                });
            }
        }
        return Promise.resolve(template(firstRenderArray, array, totalNoOfPages, currentPageNo));
    },
    actions: {
        [ACTION.ON_SEARCH_RP]: debounce(onSearchReferredPartner, 500),
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.CTA_WHATSAPP]: onCtaWhatsApp,
        [ACTION.CTA_TELEGRAM]: onCtaTelegram,
        [ACTION.CTA_COPY_LINK]: onCtaCopyLink,
        [ACTION.CTA_SHARE_LINK]: onCtaShareLink,
        [ACTION.KNOW_MORE]: onKnowMore,
        [ACTION.FAQ]: onFaq,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.APPEND_COUNTER]: appendCounter,
        [ACTION.MINUS_COUNTER]: minusCounter,
    },
};
